import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@/components/material-ui-kit/components/Accordion/Accordion';
import styles from 'styles/jss/original/components/shoppings/detailDescription';
import { IShopping } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  shopping: IShopping;
};

const DetailDescription: React.FC<ComponentProps> = ({ shopping }) => {
  const { itemDesc, scene, checkPoint } = shopping.fields;
  const classes = useStyles();
  const createText = useCallback(
    (accordionData) => (
      <ul>
        {accordionData.map((item: string[], index: number) => (
          <li key={`scene-item-${index.toString()}`}>{item}</li>
        ))}
      </ul>
    ),
    []
  );

  return (
    <div className={classes.section}>
      <Accordion
        active={[0]}
        activeColor='warning'
        collapses={[
          {
            title: 'アイテム説明',
            content: <p>{itemDesc}</p>
          },
          {
            title: '利用シーン',
            content: <div>{createText(scene)}</div>
          },
          {
            title: 'チェックポイント',
            content: <div>{createText(checkPoint)}</div>
          }
        ]}
      />
    </div>
  );
};

export default DetailDescription;
